<template>
  <div
    class="flex gap-2"
    :class="{ 'sm:gap-6': !smallGap }"
  >
    <round-radio-button
      :item="'Yes'"
      :value="true"
      :name="name"
      :checked="yesChecked"
      :handle-click="handleClick"
    />
    <round-radio-button
      :item="'No'"
      :value="false"
      :name="name"
      :checked="noChecked"
      :handle-click="handleClick"
    />
  </div>
</template>

<script>
import RoundRadioButton from './RoundRadioButton.vue';
export default {
  name: 'YesNoRadioButtons',
  components: {
    'round-radio-button': RoundRadioButton,
  },
  props: {
    name: String,
    yesChecked: Boolean,
    noChecked: Boolean,
    handleClick: {
      type: Function,
      default: () => {},
    },
    smallGap: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
